import { Resources } from 'constants/resources';

import { AxiosResponse } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import {
  EntitiesSummary,
  TransactionsAmountSummary,
  TransactionsDynamicSummary,
  TransactionsSuccessSummary,
} from 'types/embedded/dashboard';

export type DashboardSummaryParams = {
  periodFrom: number;
  periodTo: number;
  timezone: string;
  merchant: string[];
  currency: string;
  provider?: string[];
  gateway?: string[];
};

export const getDashboardTransactionsSummary = async (
  filter: DashboardSummaryParams,
): Promise<TransactionsAmountSummary> => {
  const params = qs.stringify(filter, { arrayFormat: 'indices', encode: false });
  return axios
    .get(`${Resources.Dashboard}/executed_transactions_amount?${params}`)
    .then((response: AxiosResponse) => response.data);
};

export type DashboardTransactionsSuccessSummaryParams = Omit<DashboardSummaryParams, 'currency'>;

export const getDashboardTransactionsSuccessSummary = async (
  filter: DashboardTransactionsSuccessSummaryParams,
): Promise<TransactionsSuccessSummary> => {
  const params = qs.stringify(filter, { arrayFormat: 'indices', encode: false });
  return axios
    .get(`${Resources.Dashboard}/transaction_success_summary?${params}`)
    .then((response: AxiosResponse) => response.data);
};

export const getDashboardTransactionsDynamicSummary = async (
  filter: DashboardSummaryParams,
): Promise<TransactionsDynamicSummary> => {
  const params = qs.stringify(filter, { arrayFormat: 'indices', encode: false });
  return axios
    .get(`${Resources.Dashboard}/executed_transactions_amount_by_steps?${params}`)
    .then((response: AxiosResponse) => response.data);
};

export type DashboardEntitiesSummaryParams = {
  periodFrom: number;
  periodTo: number;
  timezone: string;
};

export const getDashboardMerchantsSummary = async (
  filter: DashboardEntitiesSummaryParams,
): Promise<EntitiesSummary> => {
  const params = qs.stringify(filter, { encode: false });
  return axios
    .get(`${Resources.Dashboard}/top_merchants?${params}`)
    .then((response: AxiosResponse) => response.data);
};

export const getDashboardProvidersSummary = async (
  filter: DashboardEntitiesSummaryParams,
): Promise<EntitiesSummary> => {
  const params = qs.stringify(filter, { encode: false });
  return axios
    .get(`${Resources.Dashboard}/top_providers?${params}`)
    .then((response: AxiosResponse) => response.data);
};
